import {
  required,
  requiredIf,
  sameAs,
  minLength,
  maxLength,
  email,
  minValue
} from 'vuelidate/lib/validators';

export default {
  form: {
    name: {
      required
    },
    company: {
      // required: requiredIf(form => {
      //   return _.isEmpty(form.name);
      // })
    },
  },
  form2: {
    current_password: {
      required
    },
    new_password: {
      required,
      minLength: minLength(6)
    },
    new_password_confirmation: {
      required,
      sameAs: sameAs('new_password')
    }
  },
  form3: {
    current_password: {
      required
    },
    email: {
      required,
      email
    },
    email2: {
      required,
      sameAs: sameAs('email')
    }
  },
  origins: {
    create_form: {
      first_name: {
        required: requiredIf(form => {
          console.log("firstname required", _.isEmpty(form.last_name), _.isEmpty(form.company));
          return _.isEmpty(form.last_name) && _.isEmpty(form.company);
        })
      },
      last_name: {
        required: requiredIf(form => {
          console.log("lastname required", _.isEmpty(form.first_name) ,_.isEmpty(form.company))
          return _.isEmpty(form.first_name) && _.isEmpty(form.company);
        })
      },
      company: {
        required: requiredIf(form => {
          console.log("company required", _.isEmpty(form.first_name) ,_.isEmpty(form.last_name))
          return _.isEmpty(form.first_name) && _.isEmpty(form.last_name);
        })
      },
      address: { required },
      city: { required },
      state: { required },
      postal: { required },
      postal_origin: { required },
    },
    edit_form: {
      $each: {
        first_name: {
          required: requiredIf(form => {
            return _.isEmpty(form.last_name) && _.isEmpty(form.company);
          })
        },
        last_name: {
          required: requiredIf(form => {
            return _.isEmpty(form.first_name) && _.isEmpty(form.company);
          })
        },
        company: {
          required: requiredIf(form => {
            return _.isEmpty(form.first_name) && _.isEmpty(form.last_name);
          })
        },
        address: { required },
        city: { required },
        state: { required },
        postal: { required },
        postal_origin: { required },
      }
    }
  },
  dimensions: {
    create_form: {
      name: {
        required
      },
      length: {
        required,
        minValue: minValue(1)
      },
      width: {
        required,
        minValue: minValue(1)
      },
      height: {
        required,
        minValue: minValue(1)
      }
    },
    edit_form: {
      $each: {
        name: {
          required
        },
        length: {
          required,
          minValue: minValue(1)
        },
        width: {
          required,
          minValue: minValue(1)
        },
        height: {
          required,
          minValue: minValue(1)
        }
      }
    }
  },
  validationGroup: [
    'form',
    'form2',
    'form3',
    'origins.create_form',
    'origins.edit_form',
    'dimensions.create_form',
    'dimensions.edit_form',
  ]
};



// WEBPACK FOOTER //
// ./resources/assets/js/views/MyAccount/validations.js